import * as React from "react";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import store from './app/store';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode >
    {/* <BrowserRouter> */}
      <Provider store={store}>
        <App />
      </Provider>
    {/* </BrowserRouter> */}
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

